<div
    *ngIf="state.open"
    class="fixed inset-0 z-[140] flex items-center justify-center bg-black/55 p-3 backdrop-blur-sm sm:p-6"
    (click)="close()"
>
    <section
        class="flex h-[min(92vh,980px)] w-full max-w-7xl flex-col overflow-hidden rounded-[28px] border border-white/20 bg-[color:var(--card)] shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-label="Media library picker"
        (click)="$event.stopPropagation()"
    >
        <header class="flex items-center justify-between gap-4 border-b border-[color:var(--border)] px-4 py-4 sm:px-6">
            <div class="min-w-0">
                <p class="text-xs font-semibold uppercase tracking-[0.24em] text-[color:var(--muted-foreground)]">Media picker</p>
                <h2 class="truncate text-lg font-semibold text-[color:var(--foreground)]">{{ state.title }}</h2>
            </div>
            <button
                type="button"
                (click)="close()"
                class="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--border)] bg-[color:var(--background)] text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                aria-label="Close media library"
            >
                <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
            </button>
        </header>

        <div class="border-b border-[color:var(--border)] px-4 py-3 text-sm text-[color:var(--muted-foreground)] sm:px-6">
            The media picker now opens in a normal popup with the full <span class="font-semibold text-[color:var(--foreground)]">app-org-media-library</span> flow. If your browser blocked it, open it again from here.
        </div>

        <div class="min-h-0 flex-1 bg-[color:var(--background)] px-4 py-5 sm:px-6">
            <div class="flex h-full flex-col justify-between rounded-[24px] border border-dashed border-[color:var(--border)] bg-[color:var(--muted)] p-5 sm:p-6">
                <div class="space-y-4">
                    <div class="inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] text-[color:var(--foreground)]">
                        <lucide-icon name="images" class="h-6 w-6"></lucide-icon>
                    </div>
                    <div>
                        <h3 class="text-lg font-semibold text-[color:var(--foreground)]">Popup blocked</h3>
                        <p class="mt-2 text-sm leading-6 text-[color:var(--muted-foreground)]">
                            Use the popup to browse existing media, upload a new asset, then assign it directly into the current field without any iframe embedding.
                        </p>
                    </div>
                    <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-3 text-xs text-[color:var(--muted-foreground)] break-all">
                        {{ state.popupUrl || 'Popup URL unavailable.' }}
                    </div>
                </div>

                <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
                    <button
                        type="button"
                        (click)="close()"
                        class="inline-flex items-center justify-center rounded-2xl border border-[color:var(--border)] bg-[color:var(--background)] px-4 py-3 text-sm font-medium text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        (click)="retryPopup($event)"
                        class="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#AA9072] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#967a5a]"
                    >
                        <lucide-icon name="external-link" class="h-4 w-4"></lucide-icon>
                        Open media library
                    </button>
                </div>
            </div>
        </div>
    </section>
</div>
